import React from "react";
import { TRAINING_TOPICS } from "../lib/siteData";

export default function TrainingTopics() {
  return (
    <section
      id="trainings"
      data-testid="trainings-section"
      className="py-20 sm:py-28"
    >
      <div className="container-prose">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <p className="overline">06 — Trainings & Areas of Expertise</p>
            <h2 className="h2-display mt-4 text-4xl sm:text-5xl text-ink">
              What I bring to your <span className="italic text-forest">school, district or convention</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="body-prose text-ink/70 text-base sm:text-lg">
              Sessions are deeply aligned to NEP&nbsp;2020 and NCF-SE&nbsp;2023, and shaped to your context —
              from one-day TOTs to year-long capacity-building partnerships.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/15">
          {TRAINING_TOPICS.map((cat, i) => (
            <div
              key={cat.category}
              data-testid={`training-cat-${i}`}
              className="bg-ivory p-8 sm:p-10 hover:bg-ivorySoft transition-colors"
            >
              <p className="overline">{`0${i + 1}`}</p>
              <h3
                className="mt-3 text-2xl sm:text-3xl text-ink"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
              >
                {cat.category}
              </h3>
              <ul className="mt-6 space-y-3">
                {cat.items.map((it, j) => (
                  <li
                    key={j}
                    className="flex gap-3 body-prose text-[15px] text-ink/80"
                  >
                    <span className="mt-2 h-px w-3 bg-forest shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
